"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
const foundation_1 = require("../foundation");
exports.delay = {
    productive: {
        fast: {
            ids_delay_productive_fast_01: foundation_1.foundation_delay.delay.delay_50ms,
            ids_delay_productive_fast_02: foundation_1.foundation_delay.delay.delay_100ms,
        },
        moderate: {
            ids_delay_productive_moderate: foundation_1.foundation_delay.delay.delay_150ms,
        },
    },
    expressive: {
        moderate: {
            ids_delay_productive_moderate: foundation_1.foundation_delay.delay.delay_500ms,
        },
        slow: {
            ids_delay_expressive_slow: foundation_1.foundation_delay.delay.delay_1s,
        },
    }
};
//# sourceMappingURL=delay.js.map